import ProgressFeedbackPage from "@components/ProgressFeedbackPage"
import { useTranslation } from "react-i18next"

export default function ProgressPlan() {
  const { t } = useTranslation()

  return (
    <ProgressFeedbackPage
      steps={[
        {
          label: t("pages.onboarding.progressPlan.step1"),
          durationMs: 1500,
        },
        {
          label: t("pages.onboarding.progressPlan.step2"),
          durationMs: 1800,
        },
        {
          label: t("pages.onboarding.progressPlan.step3"),
          durationMs: 1200,
        },
        {
          label: t("pages.onboarding.progressPlan.step4"),
          durationMs: 1000,
        },
      ]}
      resultTitleKey="pages.onboarding.progressPlan.resultTitle"
      resultTextKey="pages.onboarding.progressPlan.resultText"
      buttonKey="pages.onboarding.progressPlan.button"
      hiddenInputName="progressPlan"
    />
  )
}
